import { makeStyles } from '@map/theme';
import { Typography } from '@mui/material';

const useStyles = makeStyles(({ borderRadius, palette, spacing }) => ({
  cookieDetails: {
    backgroundColor: palette.neutrals[200],
    borderRadius: borderRadius('l'),
    margin: spacing(2, 0),
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(3, 6),
    rowGap: spacing(3),
  },
  cookieDetailsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: spacing(2),
  },
  cookieDetailTitle: {
    fontWeight: 'bold',
    minWidth: '30%',
  },
  cookieDetailDescription: {
    textAlign: 'left',
    flexGrow: '1',
  },
}));

type Props = {
  name: string;
  duration: string;
  description: string;
};

const CookieDetail = ({ name, duration, description }: Props) => {
  const { classes } = useStyles();

  return (
    <div className={classes.cookieDetails}>
      <div className={classes.cookieDetailsRow}>
        <Typography className={classes.cookieDetailTitle} variant="body3">
          Cookie
        </Typography>
        <Typography className={classes.cookieDetailDescription} variant="body3">
          {name}
        </Typography>
      </div>

      <div className={classes.cookieDetailsRow}>
        <Typography className={classes.cookieDetailTitle} variant="body3">
          Duration
        </Typography>
        <Typography className={classes.cookieDetailDescription} variant="body3">
          {duration}
        </Typography>
      </div>

      <div className={classes.cookieDetailsRow}>
        <Typography className={classes.cookieDetailTitle} variant="body3">
          Description
        </Typography>
        <Typography className={classes.cookieDetailDescription} variant="body3">
          {description}
        </Typography>
      </div>
    </div>
  );
};

export default CookieDetail;
